import moment from 'moment';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { BRANCH_DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { IBranch } from 'src/types/branches';
import { getPaymentMethodIcon } from 'src/utils/helpers';
import { BRANCHES_AVAILABILITY_OPTION } from 'src/view/screens/BranchesManagementScreen/screens/BranchesScreen/constants/branches';

/**
 * Get list of branch order types icon names
 *
 * @param branch
 */
export const getBranchOrderTypeIconNames = (branch: IBranch | undefined): Icons[] => {
  const icons: Icons[] = [];

  switch (branch?.delivery_type) {
    case BRANCH_DELIVERY_TYPE.PICKUP:
      if (branch?.is_pickup) {
        icons.push(Icons.ShoppingBag);
        break;
      }
      break;
    case BRANCH_DELIVERY_TYPE.BOTH:
      icons.push(Icons.Delivery);

      if (branch?.is_pickup) {
        icons.push(Icons.ShoppingBag);
      }
      break;
    default:
      if (branch?.is_pickup) {
        icons.push(Icons.ShoppingBag);
      }
      icons.push(Icons.Delivery);
      break;
  }

  if (branch?.is_emenu) icons.push(Icons.DineIn);
  if (branch?.is_curbside) icons.push(Icons.Curbside);

  return icons;
};

/**
 * Get list of branch payment types icon names
 *
 * @param paymentTypes
 */
export const getBranchPaymentIconNames = (paymentTypes: IBranch['payment_types'] | undefined): Icons[] => {
  return paymentTypes?.map((paymentType) => getPaymentMethodIcon(paymentType.id)) || [];
};

/**
 * Get branch end work date with time in string
 *
 * @param closetDay
 */
export const getBranchEndWorkDateWithTime = (closetDay: IBranch['closest_day']) => {
  const date: string = moment().day(closetDay.working_day).format('DD/MM/YYYY');
  const time: string = moment(closetDay.close_time, ['HH:mm']).format('hh:mm A');
  return `${date}, ${time}`;
};

/**
 * Get branches availability for api params
 *
 * @param availability
 */
export const getBranchesAvailabilityParams = (availability: BRANCHES_AVAILABILITY_OPTION | null) => {
  const params: any = {};

  if (availability === BRANCHES_AVAILABILITY_OPTION.ACTIVE) {
    params.status = 1;
  } else if (availability === BRANCHES_AVAILABILITY_OPTION.INACTIVE) {
    params.status = 0;
  } else if (availability === BRANCHES_AVAILABILITY_OPTION.DELETED) {
    params.is_delete = 1;
  }

  return params;
};

/**
 * Calculate branches table columns width
 *
 * @param isPosEnabled
 * @param isFranchiseEnabled
 * @param isFranchiseBranchesEnabled
 */
export const getBranchesTableColumnsWidth = (
  isPosEnabled: boolean | undefined,
  isFranchiseEnabled: boolean | undefined,
  isFranchiseBranchesEnabled: boolean | undefined
) => {
  // 6 columns by default
  // 7 columns with franchise enabled
  // 8 columns with franchise branches integration and POS enabled
  const numOfColumns: number = 6 + +Boolean(isFranchiseEnabled) + (isFranchiseBranchesEnabled && isPosEnabled ? 1 : 0);

  switch (numOfColumns) {
    case 8:
      return [16, 12];
    case 7:
      return [16, 14];
    default:
      return [30, 14];
  }
};
